import { Money, Name } from 'types/ts';

export type BereavedPerson = {
  name: Name;
};

export type BereavedPersonConnection = {
  isBillPayer: boolean;
  bereavedPerson: BereavedPerson;
};

export type DeceasedPerson = {
  dateOfBirth: string;
  deathDateTime: string;
  name: Name;
};

export enum InvoiceType {
  INVOICE = 'INVOICE',
  PROFORMA = 'PROFORMA',
}

export type Invoice = {
  id: string;
  dateVoided: string;
  number: string;
  totals: {
    total: Money;
    taxTotal: Money;
    totalWithoutTax: Money;
    totalPaid: Money;
    totalCredit: Money;
    balance: Money;
  };
  invoiceType: InvoiceType;
};

export type Account = {
  invoices: Invoice[];
  proformaInvoices: Invoice[];
  totals: {
    balance: Money;
    totalCredit: Money;
    totalInvoiced: Money;
    totalPaid: Money;
    totalUnInvoiced: Money;
    totalInvoiceTemplatesUninvoiced: Money;
    totalInvoiceTemplatesInvoiced: Money;
  }
};

export type Bereavement = {
  id: string;
  account: Account;
  bereavedPeopleConnections: BereavedPersonConnection[];
  deceasedPeople: DeceasedPerson[];
};
